import React, { useEffect } from "react";

import { commonMessages } from "infrastructure/localization";
import { useLocalizedValues } from "ui/hooks";

import styles from "./ProgressBar.module.scss";

export interface IProgressBarProps {
  currentValue: number;
  maxValue?: number;
  onProgressChanged?: (currentValue: number, maxValue: number) => void;
  updateText?: (currentValue: number, maxValue: number) => string;
}

export const ProgressBar: React.FC<IProgressBarProps> = ({ currentValue, maxValue = 100, onProgressChanged, updateText }) => {
  const localizedValues = useLocalizedValues(() => ({
    progressBarText: { messageId: commonMessages.info("progressbarText"), tokens: { percentComplete: currentValue } }
  }));

  useEffect(() => {
    onProgressChanged?.(currentValue, maxValue);
  }, [currentValue, maxValue, onProgressChanged]);

  return (
    <div className={styles.base}>
      <span>{updateText ? updateText(currentValue, maxValue) : localizedValues.progressBarText}</span>
      <progress value={currentValue} max={maxValue} />
    </div>
  );
};
